import { Building2, Home, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

export default function SolutionsSection() {
  return (
    <section
      data-testid="solutions-section"
      className="px-5 py-16 md:px-8 md:py-24"
    >
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Parcours clients"
          title="Des solutions adaptées à vos besoins"
        />
        <div className="mt-10 grid gap-5 md:grid-cols-2">
          <Reveal>
            <div className="flex h-full flex-col rounded-2xl border border-cyan-400/25 bg-gradient-to-b from-cyan-400/[0.08] to-transparent p-7">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-cyan-400/30 bg-cyan-400/10">
                  <Building2 className="h-5 w-5 text-cyan-300" />
                </span>
                <h3 className="font-display text-xl font-bold text-white">
                  Vous êtes une agence immobilière ?
                </h3>
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-300">
                Externalisez vos états des lieux d'entrée et de sortie, simplifiez la gestion de
                vos rendez-vous et bénéficiez d'un partenaire de proximité dans toute la
                Métropole de Lyon.
              </p>
              <a
                href="/agences-immobilieres"
                data-testid="solutions-cta-agences"
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-cyan-400 px-6 py-3 text-sm font-semibold text-night transition-all duration-300 hover:brightness-110"
              >
                Découvrir nos solutions professionnelles
                <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-surface/50 p-7">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/15 bg-white/[0.04]">
                  <Home className="h-5 w-5 text-cyan-300" />
                </span>
                <h3 className="font-display text-xl font-bold text-white">
                  Vous êtes propriétaire ?
                </h3>
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-300">
                Faites réaliser vos états des lieux par un professionnel indépendant et recevez
                un rapport numérique détaillé pour votre location.
              </p>
              <button
                data-testid="solutions-cta-proprietaires"
                onClick={() => scrollToId("tarifs")}
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:border-cyan-400/60 hover:text-cyan-300"
              >
                Consulter les prestations et tarifs
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
